import React from 'react';
import styles from './styles/awardrm.module.css';
import photos from '../../assets/gallery/PHOTO.png';
import videos from '../../assets/gallery/VIDEOS.png';
import media from '../../assets/gallery/MEDIA.png';
import vip from '../../assets/gallery/VIP.png';
import report from '../../assets/gallery/MEDIA-LINKS.png';

import { useNavigate } from 'react-router-dom';
const GalleryRM = () => {
  const navigate = useNavigate();
  const goPathDetails = (path = '/photos') => {
    navigate(path);
  };
  return (
    <div className={styles.awardrm}>
      <div className={styles.award_item} onClick={() => goPathDetails('vip')}>
        <img
          src={vip}
          alt="vip"
          className={styles.award_categary_icon}
          loading="lazy"
        />
        <p>VIP</p>
      </div>

      <div
        className={styles.award_item}
        onClick={() => goPathDetails('photos')}
      >
        <img
          src={photos}
          alt="photos"
          className={styles.award_categary_icon}
          loading="lazy"
        />
        <p>PHOTOS</p>
      </div>

      <div
        className={styles.award_item}
        onClick={() => goPathDetails('videos')}
      >
        <img
          src={videos}
          alt="Video content"
          className={styles.award_categary_icon}
          loading="lazy"
        />
        <p>VIDEOS</p>
      </div>
      <div
        className={styles.award_item}
        onClick={() => goPathDetails('media-coverage')}
      >
        <img
          src={media}
          alt="media"
          className={styles.award_categary_icon}
          loading="lazy"
        />
        <p>MEDIA</p>
      </div>

      <div
        className={styles.award_item}
        onClick={() => goPathDetails('media-link')}
      >
        <img
          src={report}
          alt="photos"
          className={styles.award_categary_icon}
          loading="lazy"
        />
        <p>MEDIA LINKS</p>
      </div>
    </div>
  );
};

export default GalleryRM;
